import React, { Component } from "react";
import { WhisperSpinner } from "react-spinners-kit";

export default class Loading extends Component {
  render() {
    return (
      <div className="loading">
        <WhisperSpinner
          size={this.props.size ? this.props.size : 80}
          color="var(--brown1)"
          frontColor="var(--brown1)"
          backColor="var(--brown1)"
          loading={true}
        />
        {/* <div style={{marginTop:'15px'}}>Please wait...</div> */}
      </div>
    );
  }
}
